import { Component, OnInit } from '@angular/core';
import { SiteSearchService } from './../services/site-search.service';
import { AppConfig } from './../config/app-config';
import { FileSection, FileType, FileData } from './../models/fileData';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-site-search',
  templateUrl: './site-search.component.html',
  styleUrls: ['./site-search.component.css']
})
export class SiteSearchComponent implements OnInit {

  SearchQuery$: string = "";

  SearchResults$: any[] = [];

  constructor(
    private siteSearchService: SiteSearchService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private appConfig: AppConfig) {
  }

  ngOnInit() {
  }

  searchFromParam() {
    this.route.queryParams.subscribe((params) => {
      let searchQuery = params['searchQuery'];

      if (searchQuery != null) {
        this.searchSite(searchQuery);
      }
    });
  }

  searchSite(searchQuery: string) {
    this.SearchQuery$ = searchQuery;
    this.siteSearchService.runSearch(searchQuery).subscribe((response) => {

      this.SearchResults$ = response as any[];

      this.SearchResults$.forEach((val, idx, arr) => {
        val.dateAdded = this.datePipe.transform(val.dateAdded, 'yyyy-MM-dd');
      });

    }, (error) => {
      console.log(error);
    });
  }

  downloadFile(linkedId, fileSection) {

    var fileInfo = this.siteSearchService.getFileInfo(linkedId, fileSection).subscribe((response) => {

      var fileInfo = response[0];

      fileInfo.fileLocation = this.appConfig.baseUrl + '/Uploads/' + FileSection[fileInfo.fileSection] + '/' + FileType[fileInfo.fileType] + '/' + fileInfo.linkedId + '/' + fileInfo.physicalFileName;

      this.siteSearchService.downloadFile(fileInfo.fileLocation).subscribe((fileResponse) => {

        // file-type
        let fileName = fileInfo.displayFileName;
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(fileResponse.body);

        window.open(link.href, "_blank");

        //link.download = fileName;
        //link.click();
      }, (error) => {
        console.log(error);
      });

      return fileInfo;
    }, (error) => {
      console.log(error);
    });
  }

  searchNow() {
    this.searchSite(this.SearchQuery$);
  }

  ngAfterContentInit() {
    this.searchFromParam();
  }

}
